import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumToArray' })
export class EnumToArrayPipe implements PipeTransform {
  transform(enumObj: any): { key: string; value: any }[] {
    if (!enumObj) return [];
    const keys = Object.keys(enumObj).filter(k => isNaN(Number(k))); // only names
    return keys.map(k => ({ key: k, value: enumObj[k] }));
  }
}

//Usage
// <select>
//   <option *ngFor="let e of CompanyType | enumToArray" [value]="e.value">{{ e.key }}</option>
// </select>